import Auth from '@/store/modules/auth/constants';
import AuthorizationService from '@/services/authorizationService';

const authorizationService = new AuthorizationService();

export default {
  [Auth.actionTypes.setAuthInfo]({ commit }, userInfo) {
    localStorage.setItem('user-isAuthorized', true);
    localStorage.setItem('user-info', JSON.stringify(userInfo));

    commit(Auth.mutationTypes.setIsAuthorized, true);
    commit(Auth.mutationTypes.setUserInfo, userInfo);
  },

  [Auth.actionTypes.clearAuthInfo]({ commit }) {
    localStorage.removeItem('user-isAuthorized');
    localStorage.removeItem('user-info');

    commit(Auth.mutationTypes.setIsAuthorized, false);
    commit(Auth.mutationTypes.setUserInfo, {});
  },

  [Auth.actionTypes.getUserInfo]({ commit, dispatch }) {
    return authorizationService.getUserInfo()
      .then((userInfo) => {
        commit(Auth.mutationTypes.setUserLoading, false);

        dispatch(Auth.actionTypes.setAuthInfo, userInfo);
      })
      .catch(() => {
        commit(Auth.mutationTypes.setUserLoading, false);

        dispatch(Auth.actionTypes.clearAuthInfo);
      });
  },

  [Auth.actionTypes.loginUser]({ commit, dispatch }, loginInfo) {
    commit(Auth.mutationTypes.setUserLoading, true);

    return authorizationService.login(loginInfo)
      .then((userInfo) => {
        dispatch(Auth.actionTypes.setAuthInfo, userInfo);
        commit(Auth.mutationTypes.setUserLoading, false);

        return Promise.resolve(userInfo.roles);
      })
      .catch((errorType) => {
        commit(Auth.mutationTypes.setUserLoading, false);

        return Promise.reject(errorType);
      });
  },

  [Auth.actionTypes.logoutUser]({ dispatch }) {
    return authorizationService.logout()
      .then(() => {
        dispatch(Auth.actionTypes.clearAuthInfo);
      })
      .catch(() => {
        dispatch(Auth.actionTypes.clearAuthInfo);
      });
  },
};
